import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['form', 'action', 'submit', 'longitude', 'latitude', 'field']

  connect(){
    
  }

  async submit(){
    await new Promise(r => setTimeout(r, 200));
    if (window?.Android) {
      Android.onBack();
    } else if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "navigateToBack",
      });
    }
  }

  preventSubmit(){
    if(this.longitudeTarget.hasAttribute("value") && this.longitudeTarget.hasAttribute("value") && this.fieldTarget.value.length > 0){
      this.submitTarget.classList.remove("unclickable");
      this.submitTarget.classList.remove("disabled");
    } else {
      this.submitTarget.classList.add("unclickable");
      this.submitTarget.classList.add("disabled");
    }
  }
}
